export default "__VITE_ASSET__BQnoIZNM__ 288w, __VITE_ASSET__BVjC1MAn__ 432w, __VITE_ASSET__oux6Lgf4__ 576w";